import type { DashboardWidget } from '@/api/dashboardApi';
import MetricCard from './MetricCard';
import ChartWidget from './ChartWidget';
import FunnelWidget from './FunnelWidget';
import TableWidget from './TableWidget';
import ActivityFeedWidget from './ActivityFeedWidget';
import { Card } from 'antd';

interface WidgetRendererProps {
  widget: DashboardWidget;
  data?: unknown;
  loading?: boolean;
}

/**
 * Routes a widget to its type-specific renderer.
 */
export default function WidgetRenderer({ widget, data, loading }: WidgetRendererProps) {
  switch (widget.type) {
    case 'metric_card':
      return <MetricCard widget={widget} data={data as never} loading={loading} />;
    case 'bar_chart':
    case 'pie_chart':
    case 'line_chart':
      return <ChartWidget widget={widget} data={data as never} loading={loading} />;
    case 'funnel':
      return <FunnelWidget widget={widget} data={data as never} loading={loading} />;
    case 'table':
      return <TableWidget widget={widget} data={data as never} loading={loading} />;
    case 'activity_feed':
      return <ActivityFeedWidget widget={widget} data={data as never} loading={loading} />;
    default:
      return (
        <Card size="small" style={{ height: '100%' }}>
          <div style={{ color: '#8c8c8c', textAlign: 'center', padding: 24 }}>
            Unknown widget type: {widget.type}
          </div>
        </Card>
      );
  }
}
